/* GameTricks Quick Explore: idempotent event delegation, no dependencies. */
(() => {
  if (window.__gtQuickExploreInitialized) return;
  window.__gtQuickExploreInitialized = true;
  const preferenceKey = 'gametricks_quick_explore_optout_v1';

  const savePreference = (checkbox) => {
    if (!checkbox) return;
    try {
      if (checkbox.checked) localStorage.setItem(preferenceKey, '1');
      else localStorage.removeItem(preferenceKey);
    } catch (error) {
      /* Private browsing may block storage; normal close still works. */
    }
  };

  const closeDropdown = (returnFocus = false) => {
    document.querySelectorAll('[data-gt-explore-header]').forEach((root) => {
      const trigger = root.querySelector('[data-gt-explore-trigger]');
      const panel = root.querySelector('[data-gt-explore-panel]');
      if (!trigger || !panel || panel.hidden) return;
      panel.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      if (returnFocus) trigger.focus();
    });
  };

  const init = () => {
    const dialog = document.getElementById('gt-quick-explore-modal');
    if (!dialog) return;
    const checkbox = dialog.querySelector('[data-gt-explore-optout]');
    if (!checkbox) return;

    checkbox.addEventListener('change', () => savePreference(checkbox));

    dialog.addEventListener('close', () => savePreference(checkbox));
    dialog.addEventListener('click', (event) => {
      if (!event.target.closest('[data-gt-explore-dismiss]')) return;
      savePreference(checkbox);
      dialog.close();
    });

    let optedOut = false;
    try { optedOut = localStorage.getItem(preferenceKey) === '1'; } catch (error) {}
    if (!optedOut && !dialog.open && typeof dialog.showModal === 'function') {
      dialog.showModal();
    }
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-gt-explore-trigger]');
    if (trigger) {
      const root = trigger.closest('[data-gt-explore-header]');
      const panel = root && root.querySelector('[data-gt-explore-panel]');
      if (!panel) return;
      const opening = panel.hidden;
      closeDropdown();
      panel.hidden = !opening;
      trigger.setAttribute('aria-expanded', opening ? 'true' : 'false');
      return;
    }
    if (!event.target.closest('[data-gt-explore-header]')) closeDropdown();
    else if (event.target.closest('.gt-explore-dropdown .gt-explore-link')) closeDropdown();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeDropdown(true);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once:true });
  else init();
})();